import React, { FC } from 'react';

import * as S from './CustomListItem.styles';

interface IProps {
  isVisible?: boolean;
  isActive?: boolean;
  actions?: React.ReactNode[];
  onClick: () => void;
  id?: string;
}

const CustomListItem: FC<IProps> = ({
  isVisible = true,
  isActive = false,
  id,
  children,
  onClick,
  actions,
}) => {
  return (
    <S.VisibilityListItemWrapper $isVisible={isVisible} id={id}>
      <S.ListItem $active={isActive} onClick={onClick} actions={actions}>
        {children}
      </S.ListItem>
    </S.VisibilityListItemWrapper>
  );
};

export default CustomListItem;
